/**
 * DIgServer API
 * API for Ig Receptor gene data
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ReportsService {

    protected basePath = 'https://localhost/api';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     *
     *
     * @param species
     * @param genomicDatasets
     * @param repDatasets
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportsApi(species?: string, genomicDatasets?: string, repDatasets?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getReportsApi(species?: string, genomicDatasets?: string, repDatasets?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getReportsApi(species?: string, genomicDatasets?: string, repDatasets?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getReportsApi(species?: string, genomicDatasets?: string, repDatasets?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (species !== undefined && species !== null) {
            queryParameters = queryParameters.set('species', <any>species);
        }
        if (genomicDatasets !== undefined && genomicDatasets !== null) {
            queryParameters = queryParameters.set('genomic_datasets', <any>genomicDatasets);
        }
        if (repDatasets !== undefined && repDatasets !== null) {
            queryParameters = queryParameters.set('rep_datasets', <any>repDatasets);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/reports/reports/list`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param reportName
     * @param format
     * @param species
     * @param genomicDatasets
     * @param genomicFilters
     * @param repDatasets
     * @param repFilters
     * @param params
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportsRunApi(reportName: string, format?: string, species?: string, genomicDatasets?: string, genomicFilters?: string, repDatasets?: string, repFilters?: string, params?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getReportsRunApi(reportName: string, format?: string, species?: string, genomicDatasets?: string, genomicFilters?: string, repDatasets?: string, repFilters?: string, params?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getReportsRunApi(reportName: string, format?: string, species?: string, genomicDatasets?: string, genomicFilters?: string, repDatasets?: string, repFilters?: string, params?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getReportsRunApi(reportName: string, format?: string, species?: string, genomicDatasets?: string, genomicFilters?: string, repDatasets?: string, repFilters?: string, params?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (reportName === null || reportName === undefined) {
            throw new Error('Required parameter reportName was null or undefined when calling getReportsRunApi.');
        }








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (format !== undefined && format !== null) {
            queryParameters = queryParameters.set('format', <any>format);
        }
        if (species !== undefined && species !== null) {
            queryParameters = queryParameters.set('species', <any>species);
        }
        if (genomicDatasets !== undefined && genomicDatasets !== null) {
            queryParameters = queryParameters.set('genomic_datasets', <any>genomicDatasets);
        }
        if (genomicFilters !== undefined && genomicFilters !== null) {
            queryParameters = queryParameters.set('genomic_filters', <any>genomicFilters);
        }
        if (repDatasets !== undefined && repDatasets !== null) {
            queryParameters = queryParameters.set('rep_datasets', <any>repDatasets);
        }
        if (repFilters !== undefined && repFilters !== null) {
            queryParameters = queryParameters.set('rep_filters', <any>repFilters);
        }
        if (params !== undefined && params !== null) {
            queryParameters = queryParameters.set('params', <any>params);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/reports/reports/run/${encodeURIComponent(String(reportName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param jobId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportsStatus(jobId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getReportsStatus(jobId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getReportsStatus(jobId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getReportsStatus(jobId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (jobId === null || jobId === undefined) {
            throw new Error('Required parameter jobId was null or undefined when calling getReportsStatus.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/reports/reports/status/${encodeURIComponent(String(jobId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
